import * as React from 'react';
import { useParams } from 'react-router-dom';
import Axios from "axios";
import Swal from 'sweetalert2';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Layout from '../Layout/Layout';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

async function getData(id) {
  try {
    let result = await Axios.get(`${process.env.REACT_APP_BACKEND_DOMAIN_API}/cms_user/info/${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem('accessToken')
        }
      });
    if(result.data.status == 'success'){
      return result.data.data;
    }else{
      return { message: "failed" };     
    }
  } catch (error) {
    console.log(`bigc-online-catalogs: ${error}`);
  }
}


async function saveUser(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    let result = await Axios.post(process.env.REACT_APP_BACKEND_DOMAIN_API + '/cms_user/insert',
      payload, {
      headers: {
        'Content-Type': 'application/json',
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        "x-access-token": sessionStorage.getItem('accessToken')
      }
    });
    if(result.data.status == 'success'){
      return result.data.message;
    }else{
      return { message: "insert failed" };     
    }
  } catch (error) {
    console.log(`bigc-online-catalogs: ${error}`);
    return { message: "insert failed" };
  }
}

async function updateUser(credentials) {
  try {
    let payload = JSON.stringify(credentials);

    let result = await Axios.post(process.env.REACT_APP_BACKEND_DOMAIN_API + '/cms_user/update',
      payload, {
      headers: {
        'Content-Type': 'application/json',
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        "x-access-token": sessionStorage.getItem('accessToken')
      }
    });
    if(result.data.status == 'success'){
      return result.data.message;
    }else{
      return { message: "update failed" };     
    }
  } catch (error) {
    console.log(`bigc-online-catalogs: ${error}`);
    return { message: "update failed" };
  }
}

export default function Profile() {

  const { id } = useParams();
  const [userId, setUserId] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [status, setStatus] = React.useState('1');
  const [roleId, setRoleId] = React.useState('2');
  const [isError, setIsError] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [errorEmailFormat, setErrorEmailFormat] = React.useState(false);
  

  React.useEffect(async () => {
    if (id) {
      const getUser = await getData(id);
      //console.log(getUser);

      setUserId(getUser.id);
      setFirstName(getUser.first_name);
      setLastName(getUser.last_name);
      setEmail(getUser.email);
      setStatus(getUser.status);
      setRoleId(getUser.role_id);
      //setPassword(getUser.password);
    }
  }, [id]);

  let handleEmail = ( event ) => {
    const email = event.target.value;
    // don't remember from where i copied this code, but this works.
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if ( re.test(email) ) {
        setErrorEmailFormat(false);
    }
    else {
        setErrorEmailFormat(true);
    }

}
  const handleChange = (event, setTarget) => {
    event.preventDefault();
    const value = event.target.value;

    switch (setTarget) {
      case 'first_name': setFirstName(value); break;
      case 'last_name': setLastName(value); break;
      case 'email': setEmail(value);setErrorEmailFormat(false);break;
      case 'password': setPassword(value); break;
      case 'status': setStatus(value); break;
      case 'role_id': setRoleId(value); break;
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsError(true);
    //const myFile = formRef.current;
    if ((!firstName) || (!lastName) || (!email) || (errorEmailFormat)) {
      Swal.fire({
        icon: 'error',
        title: 'Input Failed',
      });
    } else {
      setIsError(true);
      setSubmitted(true);
      let response,jsonData;
      if (userId) {
        if(password){
          jsonData = {
            id: userId,
            first_name: firstName,
            last_name: lastName,
            email: email,
            password: password,
            status: status,
            role_id: roleId
          };
        }else{
          jsonData = {
            id: userId,
            first_name: firstName,
            last_name: lastName,
            email: email,
            status: status,
            role_id: roleId

          };    
        }
        response = await updateUser(jsonData);
      }
      else {
        response = await saveUser({
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
          status: status,
          role_id: roleId
      });
      }
      if (response === 'success') {
        Swal.fire({
          icon: 'success',
          title: response
        }).then(() => {
          setSubmitted(false);
          window.location.href = "/cms-account";
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: response,
        }).then(() => {
          setSubmitted(false);
        });
      }
    }
  }

  return (
    <Layout>
      <Paper sx={{ height: 850, width: '100%' }}>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          sx={{ minHeight: '100vh', p: 5 }}
        >
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { mb: 5, width: 500 },
            }}
            noValidate
            autoComplete="off"
            onSubmit={e => handleSubmit(e)}
          >
            <h2>User Account</h2>
            <TextField
              required
              fullWidth
              id="first_name"
              label="First Name"
              value={firstName}
              error={!firstName && isError}
              //focused={dataRichId}
              onChange={e => handleChange(e, 'first_name')}
            />
            <br />
            <TextField
              required
              fullWidth
              id="last_name"
              label="Last Name"
              value={lastName}
              error={!lastName && isError}
              //focused={dataRichId}
              onChange={e => handleChange(e, 'last_name')}
            />
            <br />
            <TextField
              required={!userId}
              disabled={!!userId}
              fullWidth
              id="email"
              label="Email"
              value={email}
              error={(!email && isError) || errorEmailFormat}
              onBlur={e => handleEmail(e, 'email')}
              onChange={e => handleChange(e, 'email')}
           />
            <br />
            <TextField
              fullWidth
              required={!userId}
              type="password"
              id="password"
              label="Password"
              value={password}
              error={!userId && !password && isError}
              onChange={e => handleChange(e, 'password')}
            />
             <br />
            <TextField
              select
              required
              fullWidth
              id="role_id"
              name="role_id"
              label="Role"
              value={roleId}
              error={!roleId && isError}
              onChange={e => handleChange(e, 'role_id')}
            >
              <MenuItem value='2'>User</MenuItem>
              <MenuItem value='1'>Admin</MenuItem>
            </TextField>
            <br />
            <TextField
              select
              required
              fullWidth
              id="status"
              name="status"
              label="Status"
              value={status}
              error={!status && isError}
              //focused={dataStatus}
              onChange={e => handleChange(e, 'status')}
            >
              <MenuItem value='1'>Active</MenuItem>
              <MenuItem value='2'>Inactive</MenuItem>
            </TextField>
            <br />
            <Button
              color="primary"
              variant="contained"
              type="submit"
              disabled={submitted}
            >
              {
                (submitted && 'Process')
                || (!submitted && 'Save')
              }
            </Button>
          </Box>

        </Grid>

      </Paper>
    </Layout>
  );
}

